import Vue from 'vue'
import Router from 'vue-router'
import Guard from './services/middleware'
import Contribute from './components/Contribute/index.vue'
// import About from './components/About/index.vue'
// import GreenDrop from './components/GreenDrop/index.vue'
import Contact from './components/Contact/index.vue'
import Community from './components/Community/index.vue'
import Saft from './components/Saft/index.vue'

// Account
import SignUp from './components/Account/SignUp.vue'
import SignIn from './components/Account/SignIn.vue'
import SignInNew from './components/Account/SignInNew.vue'
import ConfirmProject from './components/Account/ConfirmProject.vue'
import ResetPassword from './components/Account/ResetPassword/index.vue'
import Dashboard from './components/Account/Dashboard.vue'
import RegisterMyCompany from './components/Account/RegisterMyCompany/index.vue'
import ConfirmCompany from './components/Account/ConfirmCompany/index.vue'
import RejectLetter from './components/Account/RejectLetter/index.vue'
import EditProfile from './components/Account/EditProfile/index.vue'
import SettingsProfile from './components/Account/SettingsProfile/index.vue'
import EditPayment from './components/Account/EditPayment/index.vue'
import Wallet from './components/Account/Wallet.vue'

// Permissions
import Particulars from './components/Account/Permissions/Roles/Particulars/index.vue'
import Affiliate from './components/Account/Permissions/Roles/Affiliate/index.vue'
import Consumers from './components/Account/Permissions/Roles/Consumers/index.vue'
import RenewableEnergyProducers from './components/Account/Permissions/Roles/RenewableEnergyProducers/index.vue'
import ParticularProsumer from './components/Account/Permissions/Roles/ParticularProsumer/index.vue'
import IndustrialProsumer from './components/Account/Permissions/Roles/IndustrialProsumer/index.vue'
import CarbonEnergyGeneratior from './components/Account/Permissions/Roles/CarbonEnergyGeneratior/index.vue'

import Blog from './components/Blog/index.vue'

// Marketplace
import Checkout from './components/Marketplace/Checkout/index.vue'
import CheckoutNew from './components/Marketplace/CheckoutNew/index.vue'
import MarketBoard from './components/Marketplace/MarketBoard/index.vue'
import ProductDetails from './components/Marketplace/Product/Details/index.vue'
import ServicesAdd from './components/Marketplace/Services/Add/index.vue'
import ServicesDetails from './components/Marketplace/Services/Details/index.vue'
import ServicesPrivate from './components/Marketplace/Services/Private/index.vue'
import ServicesEdit from './components/Marketplace/Services/Edit/index.vue'
import ServicesDuplicate from './components/Marketplace/Services/Duplicate/index.vue'
import ProductAdd from './components/Marketplace/Product/Add/index.vue'
import ProductPrivate from './components/Marketplace/Product/Private/index.vue'
import ProductEdit from './components/Marketplace/Product/Edit/index.vue'
import ProductDuplicate from './components/Marketplace/Product/Duplicate/index.vue'

// Trade of CO2
import TradeBoard from './components/TradeOfCO2/TradeBoard/index.vue'
import TradeDetails from './components/TradeOfCO2/TradeDetails/index.vue'

// Projects
import Projects from './components/Project/Projects/index.vue'
import ProjectsPublic from './components/Project/ProjectsPublic/index.vue'
import MyProjects from './components/Project/MyProjects/index.vue'
import GreenFund from './components/Project/GreenFund/index.vue'
import GreenFundAdd from './components/Project/GreenFund/FundProjectAdd/index.vue'
import GreenFundProjectProfile from './components/Project/GreenFundProjectProfile/index.vue'
import ProjectCrowdfunding from './components/Project/SystemsDetail/ProjectCrowdfunding/index.vue'
import ProjectCrowdfundingAdd from './components/Project/SystemsDetail/ProjectCrowdfundingAdd/index.vue'
import ProjectCrowdfundingEdit from './components/Project/SystemsDetail/ProjectCrowdfundingEdit/index.vue'
import ProjectExisting from './components/Project/SystemsDetail/ProjectExisting/index.vue'
import ProjectExistingAdd from './components/Project/SystemsDetail/ProjectExistingAdd/index.vue'
import ProjectExistingDuplicate from './components/Project/SystemsDetail/ProjectExistingDuplicate/index.vue'
import ProjectDetails from './components/Project/ProjectDetails/index.vue'
import ProductSolarPet from './components/ProductSolarPet/index.vue'
import SolarPet from './components/Project/SystemsDetail/ProjectExisting/SolarPet.component.vue'
import SolarEdge from './components/Project/SolarEdge.vue'


import Report from './components/Account/MyProfile/Widget/ProjectSendReport.vue'
// import SentCarbon from './components/Account/MyProfile/Widget/ProjectCarbonCredits.vue'

import AddPaymentMethod from './components/Account/EditPayment/addPayment.vue'

import Cookie from './components/CookiePolicy/index.vue'

import Ethertest from './components/Ethertest/index.vue'
import ls from 'vue-localstorage'

Vue.use(ls)
Vue.use(Router)

console.log("this ")
console.log(this, Guard)
const router = new Router({
  routes: [
    {
      path: '/',
      name: 'signin',
      component: SignInNew,
    },
    {
      path: '/kyc/:id/:token',
      name: 'Contribute',
      component: Contribute,
      beforeEnter: Guard.guest,
    },
    {
      path: '/kyc',
      name: 'Contribute',
      component: Contribute,
      beforeEnter: Guard.guest,
    },
    {
      path: '/signup',
      name: 'SignUp',
      component: SignUp,
      beforeEnter: Guard.guest,
    },
    {
      path: '/signin',
      name: 'SignIn',
      component: SignIn,
      beforeEnter: Guard.guest,
    },
    {
      path: '/confirm_project/:id',
      name: 'ConfirmProject',
      component: ConfirmProject,
    },
    {
      path: '/forgot',
      name: 'ResetPassword',
      component: ResetPassword,
      beforeEnter: Guard.guest,
    },
    {
      path: '/reset_password/:token',
      name: 'UpdatePassword',
      component: ResetPassword,
      beforeEnter: Guard.guest,
    },
    {
      path: '/confirm_company/:title/:email/:token',
      name: 'ConfirmCompany',
      component: ConfirmCompany,
      beforeEnter: Guard.guest,
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      beforeEnter: Guard.auth,
    },
    {
      path: '/wallet',
      name: 'Wallet',
      component: Wallet,      
    },
    {
      path: '/settings',
      name: 'SettingsProfile',
      component: SettingsProfile,
      beforeEnter: Guard.auth,
    },
    {
      path: '/payment/edit',
      name: 'EditPayment',
      component: EditPayment,
      beforeEnter: Guard.auth,
    },
    {
      path: '/myprofile/edit',
      name: 'EditProfile',
      component: EditProfile,
      beforeEnter: Guard.auth,
    },
    {
      path: '/myprofile/registermycompany',
      name: 'RegisterMyCompany',
      component: RegisterMyCompany,
      beforeEnter: Guard.auth,
    },
    {
      path: '/rejectletter',
      name: 'RejectLetter',
      component: RejectLetter,
    },
    {
      path: '/myprofile/particulars',
      name: 'Particulars',
      component: Particulars,
    },
    {
      path: '/myprofile/affiliate',
      name: 'Affiliate',
      component: Affiliate,
    },
    {
      path: '/myprofile/consumers',
      name: 'Consumers',
      component: Consumers,
    },
    {
      path: '/myprofile/renewableenergyproducers',
      name: 'RenewableEnergyProducers',
      component: RenewableEnergyProducers,
    },
    {
      path: '/myprofile/particularprosumer',
      name: 'ParticularProsumer',
      component: ParticularProsumer,
    },
    {
      path: '/myprofile/industrialprosumer',
      name: 'IndustrialProsumer',
      component: IndustrialProsumer,
    },
    {
      path: '/myprofile/carbonenergygeneratior',
      name: 'CarbonEnergyGeneratior',
      component: CarbonEnergyGeneratior,
    },
    /*{
      path: '/checkout',
      name: 'Checkout',
      component: Checkout,
    },*/
    {
      path: '/checkout',
      name: 'Checkout',
      component: CheckoutNew,
    },
    {
      path: '/marketplace',
      name: 'Marketplace',
      component: MarketBoard,
    },
    {
      path: '/product/add',
      name: 'ProductAdd',
      component: ProductAdd,
    },
    {
      path: '/product/private/:id',
      name: 'ProductPrivate',
      component: ProductPrivate,
    },
    {
      path: '/product/edit/:id',
      name: 'ProductEdit',
      component: ProductEdit,
    },
    {
      path: '/product/duplicate/:id',
      name: 'ProductDuplicate',
      component: ProductDuplicate,
    },
    {
      path: '/product/:id',
      name: 'ProductDetails',
      component: ProductDetails,
    },
    {
      path: '/service/add',
      name: 'ServicesAdd',
      component: ServicesAdd,
    },
    {
      path: '/service/:id',
      name: 'ServicesDetails',
      component: ServicesDetails,
    },
    {
      path: '/service/private/:id',
      name: 'ServicesPrivate',
      component: ServicesPrivate,
    },
    {
      path: '/service/edit/:id',
      name: 'ServicesEdit',
      component: ServicesEdit,
    },
    {
      path: '/service/duplicate/:id',
      name: 'ServicesDuplicate',
      component: ServicesDuplicate,
    },
    {
      path: '/tradeofco2',
      name: 'TradeBoard',
      component: TradeBoard,
    },
    {
      path: '/tradeofco2/details/:id',
      name: 'TradeDetails',
      component: TradeDetails,
    },
    {
      path: '/projects',
      name: 'Projects',
      component: Projects,
      beforeEnter: (to, from, next) => {
        if(localStorage.getItem('typeOfProfile') == 'investor')
          next(from.path)
        else next()
      }
    },
    {
      path: '/projects/public',
      name: 'ProjectsPublic',
      component: ProjectsPublic,
      beforeEnter: (to, from, next) => {
        if(localStorage.getItem('typeOfProfile') == 'investor')
          next(from.path)
        else next()
      }
    },
    {
      path: '/myprojects',
      name: 'MyProjects',
      component: MyProjects,
    },
    {
      path: '/greenfund',
      name: 'GreenFund',
      component: GreenFund,
    },
    {
      path: '/project/systemsdetail/existing/add',
      name: 'ProjectExistingAdd',
      component: ProjectExistingAdd,
    },
    {
      path: '/greenfund/add',
      name: 'GreenFundAdd',
      component: GreenFundAdd,
    },
    {
      path: '/greenfund/edit/:id',
      name: 'GreenFundEdit',
      component: GreenFundAdd,
    },
    {
      path: '/greenfund/:id',
      name: 'GreenFundProjectProfile',
      component: GreenFundProjectProfile,
    },
    {
      path: '/project/systemsdetail/existing/:id',
      name: 'ProjectExisting',
      component: ProjectExisting,
    },
    {
      path: '/project/systemsdetail/existing/edit/:id',
      name: 'ProjectExistingEdit',
      component: ProjectExistingAdd,
    },
    {
      path: '/project/systemsdetail/existing/duplicate/:id',
      name: 'ProjectExistingDuplicate',
      component: ProjectExistingDuplicate,
    },
    {
      path: '/project/systemsdetail/crowdfunding/add',
      name: 'ProjectCrowdfundingAdd',
      component: ProjectCrowdfundingAdd,
    },
    {
      path: '/project/systemsdetail/crowdfunding/:id',
      name: 'ProjectCrowdfunding',
      component: ProjectCrowdfunding,
    },
    {
      path: '/project/systemsdetail/crowdfunding/edit/:id',
      name: 'ProjectCrowdfundingEdit',
      component: ProjectCrowdfundingEdit,
    },
    {
      path: '/project/:id',
      name: 'ProjectDetails',
      component: ProjectDetails,
    },
    // {
    //   path: '/about',
    //   name: 'About',
    //   component: About,
    // },
    // {
    //   path: '/GreenDrop',
    //   name: 'GreenDrop',
    //   component: GreenDrop,
    // },
    {
      path: '/community',
      name: 'Community',
      component: Community,
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact,
    },
    {
      path: '/saft',
      name: 'Saft',
      component: Saft,
    },
    {
      path: '/twitter/callback',
      name: 'twitter',
      component: SignIn,
    },
    {
      path: '/linkedin',
      name: 'linkedin',
      component: SignIn,
    },
    {
      path: '/activate/:id',
      name: 'SignIn',
      component: SignIn,
    },
    {
      path: '/ethertest',
      name: 'Ethertest',
      component: Ethertest,
    },
    {
      path: '/ProductSolarPet',
      name: 'ProductSolarPet',
      component: ProductSolarPet,
    },
    {
      path: '/posts/:id',
      name: 'Blog',
      component: Blog,
    },
    {
      path: '/cookie_policy',
      name: 'Cookie',
      component: Cookie,
      beforeEnter: Guard.guest,
    },
    {
      path: '/report',
      name: 'Report',
      component: Report,
    },
    // {
    //   path: '/carbon_credits',
    //   name: 'SentCarbon',
    //   component: ProjectCarbonCredits,
    // },
    {
      path: '/payment/add_method',
      name: 'AddPayment',
      component: AddPaymentMethod,
    },
    {
      path: '/project/systemsdetail/solarpet/:id',
      name: 'SolarPet',
      component: SolarPet,
    },
    {
      path: '/solaredge/:id',
      name: 'SolarEdge',
      component: SolarEdge,
    },
    {
      path: '/login',
      name: 'SignIn',
      component: SignIn,
    },
    {
      path: '/*',
      name: '',
      component: SignInNew,
    },
    
  ],
  mode: 'history',

})

export default router


// WEBPACK FOOTER //
// ./src/routes.js